module.exports = __webpack_public_path__ + "img/baomingcanzhan.bbe6ec4f.png";